import * as React from 'react';
import { useIntl, useDispatch, useSelector } from '@grandvisionhq/state';
import { useIsFormSlotAvailable } from '../../slots/forms/form-context.js';
import '../../slots/summaries/summary-context.js';
import '../../slots/summaries/types.js';
import { ShippingObjectTypes } from '../../state.js';
import { toggleInvoice } from '../actions.js';
import { InvoiceFormComponent } from '../components/InvoiceForm.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import 'throttle-debounce';
import '@grandvisionhq/forms';
import '@grandvisionhq/carts-v2';
import { getCompany, getInvoiceFormEnabledState } from '../selectors.js';
import 'motion/react';

const InvoiceFormContainer = ()=>{
    const { getLabel  } = useIntl();
    const dispatch = useDispatch();
    const company = useSelector(getCompany);
    const isInvoiceFormEnabled = useSelector(getInvoiceFormEnabledState);
    const isInvoiceFormAvailable = useIsFormSlotAvailable(ShippingObjectTypes.Invoice);
    React.useEffect(()=>{
        // Invoice is an optional form, whenever it's defined we need to enable it in our redux state
        if (isInvoiceFormAvailable && !company && !isInvoiceFormEnabled) {
            dispatch(toggleInvoice({
                enabled: true
            }));
        }
        if (!isInvoiceFormAvailable && isInvoiceFormEnabled) {
            dispatch(toggleInvoice({
                enabled: false
            }));
        }
    // dispatch might trigger rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isInvoiceFormAvailable,
        company,
        isInvoiceFormEnabled
    ]);
    const labels = React.useMemo(()=>({
            invoiceTitle: getLabel('checkout.invoice.title')
        })
    , [
        getLabel
    ]);
    if (company) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(InvoiceFormComponent, {
        title: labels.invoiceTitle
    });
};

export { InvoiceFormContainer };
//# sourceMappingURL=InvoiceFormContainer.js.map
